<template>
  <v-layout>
    <v-dialog v-model="dialog" scrollable max-width="640px">
      <v-card>
        <v-card-text class="font-weight-light text-xs-left title underlineheadline bluetext">
          {{cellData.title}}
        </v-card-text>
        <v-card-text style="overflow: auto; max-height: 400px">

          <v-layout class="pa-4" row wrap>
            <v-flex xs12 class="text-left" v-if="cellData && cellData.type === 'delete'">
              Möchten Sie wirklich {{cellData.files.length}} Dokumente löschen?
            </v-flex>
            <v-flex xs12 class="text-left" v-if="cellData && cellData.type === 'status'">
              Wählen Sie einen Status für {{cellData.files.length}} Dokumente und klicken übernehmen.
            </v-flex>
            <v-flex xs12 class="text-left" v-if="cellData && cellData.type === 'mail'">
              Versenden Sie {{cellData.files.length}} Dokumente per Mail.
            </v-flex>
            <v-flex xs12 class="text-left" v-if="cellData && cellData.type === 'category'">
              Wählen Sie eine oder mehere Kategorien für {{cellData.files.length}} Dokumente und klicken übernehmen.
            </v-flex>

          </v-layout>
          <v-layout row v-if="cellData && cellData.type === 'mail'" justify-start>
            <v-flex xs12 sm6 class="pa-3 text-xs-left bordernone">
              <v-text-field
                v-model="mail_to"
                color="#6f6f6e"
                clearable
                class="my-input textblock pt-4 px-3"
                label="Empfänger E-Mail Adresse"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-3 text-xs-left bordernone">
              <v-text-field
                v-model="mail_to_name"
                color="#6f6f6e"
                clearable
                class="my-input textblock pt-4 px-3"
                label="Empfänger Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-3 text-xs-left bordernone">
              <v-text-field
                v-model="mail_from"
                color="#6f6f6e"
                readonly=""
                class="my-input textblock pt-4 px-3"
                label="Sender E-Mail Adresse"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-3 text-xs-left bordernone">
              <v-text-field
                v-model="mail_from_name"
                color="#6f6f6e"
                clearable
                class="my-input textblock pt-4 px-3"
                label="Sender Name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 class="pa-3 text-xs-left bordernone">
              <v-text-field
                v-model="mail_subject"
                clearable
                color="#6f6f6e"
                class="my-input textblock pt-4 px-3"
                label="E-Mail Betreff"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 class="pa-3 text-xs-left">
              <v-textarea
                v-model="mail_body"
                color="#6f6f6e"
                clearable
                solo
                class="my-input"
                label="E-Mail Text"
              ></v-textarea>
            </v-flex>
            <!--<v-flex xs6 class="pa-2 text-xs-left">
              <v-text-field
                v-model="mail_regards"
                color="#6f6f6e"
                clearable
                class="my-input textblock pt-4 px-3"
                label="Grüße"
              ></v-text-field>
            </v-flex>-->
          </v-layout>
          <v-layout row justify-center v-if="cellData && cellData.type === 'category'">
            <v-flex xs12 sm6>
              <v-combobox
                :items="categories"
                item-text="title"
                v-model="selectedCategories"
                return-object
                class="mx-4"
                chips
                close
                solo
                color="#6f6f6e"
                multiple
                label="Kategorie"
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    @input="removeCategory(data.item)"
                  >
                    <strong>{{data.item.title}}</strong>
                  </v-chip>
                </template>
              </v-combobox>

            </v-flex>
          </v-layout>
          <v-layout row justify-center v-if="cellData && cellData.type === 'status'">
            <v-flex xs6>
              <v-combobox
                v-model="currentStatus"
                :items="statusList"
                label="Status"
                item-text="title"
                return-object
                class="mx-4"
                solo
                close
                clearable
              >
              </v-combobox>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-btn class="text-none" color="#6f6f6e" outline flat @click="closeDialog()">abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="text-none" color="#6f6f6e" outline flat @click="submitDialog()" v-if="cellData && cellData.type === 'delete'">löschen</v-btn>
          <v-btn class="text-none" color="#6f6f6e" outline flat @click="submitDialog()" v-if="cellData && cellData.type === 'status'">Status ersetzen</v-btn>
          <v-btn class="text-none" color="#6f6f6e" outline flat @click="submitDialog()" v-if="cellData && cellData.type === 'category'">Kategorie ersetzen</v-btn>
          <v-btn class="text-none" color="#6f6f6e" outline flat @click="submitDialog()" v-if="cellData && cellData.type === 'mail'">E-Mail senden</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
// import Vue from 'vue'
import Vue from 'vue'

export default {
  name: 'DialogWorkOnFiles',
  components: {},
  props: ['onCloseEventName'],
  methods: {
    closeDialog: function () {
      this.dialog = false
    },
    submitDialog: function () {
      this.dialog = false
      var that = this
      that.cellData.status = this.currentStatus
      that.cellData.categories = this.selectedCategories
      that.cellData.mail_body = this.mail_body
      that.cellData.mail_to = this.mail_to
      that.cellData.mail_to_name = this.mail_to_name
      that.cellData.mail_salut = this.mail_salut
      that.cellData.mail_regards = this.mail_regards
      that.cellData.mail_from_name = this.mail_from_name
      that.cellData.mail_subject = this.mail_subject

      this.$emit('onSave', that.cellData)
    },
    removeCategory: function (item) {
      console.log('removeCategory', item)
      var index = this.selectedCategories.indexOf(item)
      if (index > -1) {
        this.selectedCategories.splice(index, 1)
      }
    },
    open: function (item) {
      console.log('item', item)
      this.cellData = item
      this.mail_from = Vue.prototype.$sasConfig.mailFromAddress
      this.dialog = true
      this.statusList = Vue.prototype.$storage.getStatusList()
      this.categories = Vue.prototype.$storage.getCategories()
    }
  },
  data () {
    return {
      currentStatus: null,
      dialog: false,
      mail_to: '',
      mail_body: '',
      mail_subject: Vue.i18n.translate('MAIL_SUBJECT'),
      mail_to_name: '',
      mail_from_name: Vue.i18n.translate('MAIL_FROM_NAME'),
      mail_salut: Vue.i18n.translate('MAIL_SALUT'),
      mail_regards: Vue.i18n.translate('MAIL_REGARDS'),
      statusList: [],
      categories: [],
      selectedCategories: null,
      config: {
        color: '#66FF44'
      },
      cellData: {}
    }
  },
  mounted () {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/DialogWorkOnFiles.vue